import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Mail, MapPin, Phone,Clock, Users, Star, Award, Utensils, Wine, Coffee, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RestaurantPage = () => {
  const navigate = useNavigate(); // ✅ define it here
  const [language, setLanguage] = useState('fr');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [scrolled, setScrolled] = useState(false);

  const content = {
    fr: {
      title: 'Restaurant Riad Lina',
      subtitle: 'Une Expérience Culinaire Inoubliable',
      description: 'Découvrez notre cuisine mêlant traditions berbères et marocaines pour le plaisir de vos papilles. Profitez de votre restaurant pendant vos vacances ou votre séjour et laissez-vous séduire par des saveurs authentiques alliant raffinement et gastronomie marocaine',
      menuTitle: 'Notre Menu Raffiné',
      categories: {
        all: 'Tous',
        entrees: 'Entrées',
        plats: 'Plats Principaux',
        desserts: 'Desserts',
        boissons: 'Boissons'
      },
      menu: [
    // ENTREES
    {
      name: 'Salade Marocaine',
      category: 'entrees',
      price: '15 DH',
      desc: '',
      img: 'img/salade_maroc.webp'
    },
    {
      name: 'Salade Niçoise',
      category: 'entrees',
      price: '25 DH',
      desc: 'Salade composée avec thon, œufs durs, tomates, olives, haricots verts et anchois',
      img: 'img/salde_noice.jpeg'
    },
    {
      name: 'Salade Crudités',
      category: 'entrees',
      price: '30 DH',
      desc: 'Assortiment de légumes crus frais de saison avec vinaigrette maison',
      img: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=500'
    },
    {
      name: 'Soupe Marocaine',
      category: 'entrees',
      price: '15 DH',
      desc: 'La soupe marocaine est une soupe épicée et nourrissante, à base de légumes et parfois de légumineuses ou de viande',
      img: 'img/soup.webp'
    },

    // PLATS
    {
      name: 'Tagine Bœuf',
      category: 'plats',
      price: '65 DH',
      desc: 'Bœuf mijoté aux pruneaux et aux épices marocaines traditionnelles',
      img: 'img/tagine_bouef.jpeg'
    },
    {
      name: 'Brochettes',
      category: 'plats',
      price: '65 DH',
      desc: 'Brochettes de viande grillées à la perfection, servies avec frites maison et salade fraîche',
      img: 'img/brouchettes.jpeg'
    },
    {
      name: 'Tagine Poulet',
      category: 'plats',
      price: '65 DH',
      desc: 'Poulet tendre aux citrons confits et olives violettes dans une sauce savoureuse',
      img: 'img/tagine_poulet.jpg'
    },
    {
      name: 'Tagine Kafta',
      category: 'plats',
      price: '65 DH',
      desc: 'Boulettes de viande hachée mijotées avec tomates cerises et œufs pochés',
      img: 'img/tagine_kfta.jpg'
    },
    {
      name: 'Tagine Végétarien',
      category: 'plats',
      price: '55 DH',
      desc: 'Légumes de saison mijotés avec des épices aromatiques et huile d\'olive',
      img: 'img/tagine_vegetarien.webp'
    },
    {
      name: 'Couscous ',
      category: 'plats',
      price: '65 DH',
      desc: 'Couscous généreux accompagné de légumes et assortiment de viandes (poulet, agneau, merguez)',
      img: 'img/couscouss.webp'
    },
    {
      name: 'Berkouks',
      category: 'plats',
      price: '65 DH',
      desc: 'Le berkouks marocain est une soupe épaisse à base de lait caillé et de semoule, simple et réconfortante',
      img: 'img/brkoukss.jpg'
    },

    // DESSERTS
    {
      name: 'Oranges à la Cannelle',
      category: 'desserts',
      price: '20 DH',
      desc: 'Oranges fraîches en rondelles parfumées à la fleur d\'oranger et cannelle',
      img: 'img/salade_canelle.jpeg'
    },
    
    {
      name: 'Fruits de Saison',
      category: 'desserts',
      price: '20 DH',
      desc: 'Sélection de fruits frais selon la saison',
      img: 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=500'
    },
    {
      name: 'Thé à la Menthe + Pâtisserie Marocaine',
      category: 'desserts',
      price: '20 DH',
      desc: 'Thé vert traditionnel infusé avec menthe fraîche et sucre, accompagné de pâtisseries marocaines',
      img: 'https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=500'
    },

    // BOISSONS
    {
      name: 'Eau Minérale 1L',
      category: 'boissons',
      price: '10 DH',
      desc: 'Eau minérale naturelle en bouteille d\'un litre',
      img: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=500'
    },
    {
      name: 'Eau Pétillante 1L',
      category: 'boissons',
      price: '10 DH',
      desc: 'Eau pétillante en bouteille d\'un litre',
      img: 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=500'
    },
    {
      name: 'Coca Cola',
      category: 'boissons',
      price: '10 DH',
      desc: 'Coca Cola en canette ou bouteille',
      img: 'https://images.unsplash.com/photo-1554866585-cd94860890b7?w=500'
    },
    {
      name: 'Sprite',
      category: 'boissons',
      price: '10 DH',
      desc: 'Sprite en canette ou bouteille',
      img: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?w=500'
    },
    {
      name: 'Schweppes',
      category: 'boissons',
      price: '10 DH',
      desc: 'Schweppes en canette ou bouteille',
      img: 'https://images.unsplash.com/photo-1624517452488-04869289c4ca?w=500'
    },
    {
      name: 'Hawaï',
      category: 'boissons',
      price: '10 DH',
      desc: 'Boisson gazeuse Hawaï',
      img: 'https://images.unsplash.com/photo-1437418747212-8d9709afab22?w=500'
    },
    {
      name: 'Jus d\'Orange ',
      category: 'boissons',
      price: '12 DH',
      desc: 'Oranges pressées à la minute, 100% naturel sans sucre ajouté',
      img: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=500'
    },
    {
      name: 'Thé à la Menthe',
      category: 'boissons',
      price: '10 DH',
      desc: 'Thé vert traditionnel infusé avec menthe fraîche et sucre',
      img: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=500'
    },
    {
      name: 'Verveine',
      category: 'boissons',
      price: '10 DH',
      desc: 'Infusion de verveine chaude et apaisante',
      img: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=500'
    },
    {
      name: 'Café Noir',
      category: 'boissons',
      price: '12 DH',
      desc: 'Café expresso noir corsé',
      img: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=500'
    },
    {
      name: 'Café au Lait',
      category: 'boissons',
      price: '10 DH',
      desc: 'Café avec lait chaud onctueux',
      img: 'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7?w=500'
    }
      ],
      features: [
        { icon: '🍽️', title: 'Cuisine Authentique', desc: 'Recettes traditionnelles marocaines' },
        { icon: '🌿', title: 'Ingrédients Frais', desc: 'Produits locaux et biologiques' },
        { icon: '💰', title: 'Tarifs', desc: 'Petit déjeuner 3 €',desc2: 'Dîner 10 €' },
        { icon: '🏆', title: 'Excellence', desc: 'Service de qualité supérieure' }
      ],
      hours: {
        title: 'Horaires d\'Ouverture',
        breakfast: 'Petit-déjeuner: 8:00 AM - 10:00 AM',
        lunch: 'Déjeuner: 12:00 PM - 2:00 PM',
        dinner: 'Dîner: 8:00 PM - 10:00 PM'
      },
      contact: {
        title: 'Réservez Votre Séjour',
        address: 'TANDILT-AMMELNE-TAFROUT',
        phone: '+212 667 624183',
        whatssap: '+212 667 624183',
        email: 'CONTACT@RAIDLINA.MA'
      },
      address: {
      subtitle: 'NOTRE ADRESSE',
      title1: 'Riad Caravane',
      title2: 'Aït Ben Haddou',
      desc: "Maison d’hôtes au Maroc – Aït Ben Haddou, 45000 Maroc",
      button: "Plan d'accès",
    },
    reserve: {
      subtitle: 'RÉSERVER UNE CHAMBRE',
      title1: 'Séjournez dans notre',
      title2: "Maison d'hôtes",
      desc: "Andréa et son équipe auront le plaisir de vous accueillir au Riad Caravane et veilleront à ce que votre séjour soit inoubliable.",
      button: 'Réservez votre séjour',
    },
      reservation: 'Réserver une Table',
      reserveNow: 'Réserver Maintenant',
      reserveText: 'Réservez votre table dès maintenant et laissez-vous transporter par une expérience culinaire exceptionnelle',
      gallery: 'Galerie Culinaire'
    },
    
  };

  const t = content[language];

  const galleryImages = [
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
    'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200',
    'https://images.unsplash.com/photo-1551218808-94e220e084d2?w=1200',
    'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200',
    'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200'
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const filteredMenu = selectedCategory === 'all' 
    ? t.menu 
    : t.menu.filter(item => item.category === selectedCategory);

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#ffffffff', color: '#000000ff' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&family=Cormorant+Garamond:wght@300;400;600;700&display=swap');
        
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Cormorant Garamond', serif; }
        
        // .fade-in { animation: fadeIn 1.2s ease-in; }
        // @keyframes fadeIn { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
        
        // .slide-up { animation: slideUp 0.8s ease-out; }
        // @keyframes slideUp { from { opacity: 0; transform: translateY(60px); } to { opacity: 1; transform: translateY(0); } }
        
        // .zoom-in { animation: zoomIn 0.6s ease-out; }
        // @keyframes zoomIn { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
        
        // .float-gentle { animation: floatGentle 8s ease-in-out infinite; }
        // @keyframes floatGentle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-15px); } }
        
        // .glow { box-shadow: 0 0 30px rgba(212, 175, 55, 0.3); }
        // .glow:hover { box-shadow: 0 0 50px rgba(212, 175, 55, 0.5); }
        
        .luxury-card {
          background: linear-gradient(145deg, #1a1a1a, #0d0d0d);
          border: 1px solid rgba(212, 175, 55, 0.2);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .luxury-card:hover {
          transform: translateY(-10px) scale(1.02);
          border-color: rgba(212, 175, 55, 0.6);
          box-shadow: 0 20px 60px rgba(212, 175, 55, 0.2);
        }
        
        
        
        
        
        .text-gradient {
          background: linear-gradient(135deg, #d4af37 0%, #f9e79f 50%, #d4af37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      {/* hero */}
      <section style={{
  position: 'relative',
  height: '100vh',
  overflow: 'hidden',
  marginTop: 0
}}>
  {galleryImages.map((img, i) => (
    <div key={i} style={{
      position: 'absolute', top: 0, left: 0,
      width: '100%', height: '90%',
      backgroundImage: `url(${img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: currentImageIndex === i ? 1 : 0,
      transition: 'opacity 2s ease-in-out',
      filter: 'brightness(0.5) saturate(1.2)'
    }} />
  ))}

  {/* Elegant golden overlay */}
  <div style={{
    position: 'absolute',
    top: 0, left: 0,
    width: '100%', height: '100%',
    background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.85))'
  }} />

  {/* Hero content */}
  <div style={{
    position: 'absolute',
    top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    width: '90%', maxWidth: '1000px',
    color: '#fff'
  }} className="fade-in">
    <h1 style={{
      fontFamily: 'Playfair Display, serif',
      fontSize: 'clamp(48px, 8vw, 90px)',
      fontWeight: 900,
      marginBottom: '25px',
      letterSpacing: '3px',
      color: '#d4af37',
      textShadow: '3px 3px 30px rgba(0,0,0,0.8)'
    }}>
      {t.title}
    </h1>
    <p style={{
      fontSize: 'clamp(22px, 4vw, 36px)',
      fontFamily: 'Lora, serif',
      fontStyle: 'italic',
      color: '#f9e79f',
      marginBottom: '40px',
      textShadow: '2px 2px 10px rgba(0,0,0,0.7)'
    }}>
      {t.subtitle}
    </p>
    <p style={{
      fontSize: 'clamp(16px, 2vw, 22px)',
      lineHeight: '1.8',
      color: '#e0e0e0',
      maxWidth: '700px',
      margin: '0 auto 50px',
      textShadow: '1px 1px 10px rgba(0,0,0,0.8)'
    }}>
      {t.description}
    </p>
    <button style={{
      background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
      color: '#000',
      padding: '16px 50px',
      fontSize: '18px',
      border: 'none',
      borderRadius: '50px',
      cursor: 'pointer',
      fontWeight: 700,
      letterSpacing: '2px',
      transition: 'all 0.4s',
      boxShadow: '0 10px 40px rgba(212, 175, 55, 0.4)',
      fontFamily: 'Playfair Display, serif'
    }}
      onClick={() => navigate('/contact')}
      onMouseEnter={e => { e.target.style.transform = 'scale(1.1)' }}
      onMouseLeave={e => { e.target.style.transform = 'scale(1)' }}>
      {t.reservation}
    </button>
  </div>
      </section>
      {/* Features Section */}
      <section style={{ padding: '100px 30px', background: '#0f0f0f' }}>
  <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px'
    }}>
      {t.features.map((feature, i) => (
        <div key={i} className="luxury-card zoom-in" style={{
          padding: '50px 30px',
          borderRadius: '20px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '60px', marginBottom: '25px' }}>{feature.icon}</div>
          <h3 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '26px',
            color: '#d4af37',
            marginBottom: '15px',
            fontWeight: 700
          }}>
            {feature.title}
          </h3>
          <p style={{ fontSize: '18px', color: '#bbb', lineHeight: '1.6' }}>
            {feature.desc}
          </p>
          {feature.desc2 && (
            <p style={{ fontSize: '18px', color: '#bbb', lineHeight: '1.6' }}>
              {feature.desc2}
            </p>
          )}
        </div>
      ))}
    </div>
  </div>
      </section>
      {/* Menu Section */}
      <section style={{ padding: '120px 30px', background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }} className="slide-up">
            <div className="ornament" style={{ margin: '0 auto 20px' }} />
            <h2 style={{
              fontFamily: 'Playfair Display, serif', fontSize: 'clamp(40px, 6vw, 70px)',
              fontWeight: 900, marginBottom: '20px'
            }} className="text-gradient">
              {t.menuTitle}
            </h2>
            <div className="gold-line" style={{ width: '150px', margin: '0 auto' }} />
          </div>

          {/* Category Filters */}
          <div style={{
            display: 'flex', justifyContent: 'center', gap: '20px',
            marginBottom: '70px', flexWrap: 'wrap'
          }}>
            {Object.entries(t.categories).map(([key, value]) => (
              <button key={key} onClick={() => setSelectedCategory(key)} style={{
                padding: '12px 35px', borderRadius: '30px', cursor: 'pointer',
                fontSize: '16px', fontWeight: 600, letterSpacing: '1px',
                transition: 'all 0.3s',
                background: selectedCategory === key ? 'linear-gradient(135deg, #d4af37, #f9e79f)' : 'transparent',
                border: selectedCategory === key ? 'none' : '2px solid #d4af37',
                color: selectedCategory === key ? '#000' : '#d4af37'
              }} onMouseEnter={e => {
                if (selectedCategory !== key) {
                  e.target.style.background = 'rgba(212, 175, 55, 0.2)';
                }
              }} onMouseLeave={e => {
                if (selectedCategory !== key) {
                  e.target.style.background = 'transparent';
                }
              }}>
                {value}
              </button>
            ))}
          </div>

          {/* Menu Items */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '35px' }}>
            {filteredMenu.map((item, i) => (
              <div key={i} className="luxury-card" style={{
                borderRadius: '20px', overflow: 'hidden'
              }}>
                <div style={{
                  height: '250px',
                  backgroundImage: `url(${item.img})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
                    color: '#000',
                    padding: '10px 20px',
                    borderRadius: '25px',
                    fontSize: '20px',
                    fontWeight: 700,
                    fontFamily: 'Playfair Display, serif',
                    boxShadow: '0 5px 20px rgba(0,0,0,0.3)'
                  }}>
                    {item.price}
                  </div>
                </div>
                <div style={{ padding: '35px' }}>
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif', fontSize: '26px',
                    color: '#d4af37', fontWeight: 700, marginBottom: '15px'
                  }}>
                    {item.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Hours Section */}
      <section style={{
        padding: '100px 30px',
        backgroundImage: 'url(https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1600)',
        backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.85)'
        }} />
        <div style={{ position: 'relative', maxWidth: '800px', margin: '0 auto', textAlign: 'center' }} className="zoom-in">
          <Clock size={60} color="#d4af37" style={{ marginBottom: '30px' }} />
          <h2 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
            marginBottom: '50px', fontWeight: 700, color: '#d4af37'
          }}>
            {t.hours.title}
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '25px', fontSize: '22px', color: '#e0e0e0' }}>
            <div style={{ padding: '20px', background: 'rgba(212, 175, 55, 0.1)', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)' }}>
              {t.hours.breakfast}
            </div>
            <div style={{ padding: '20px', background: 'rgba(212, 175, 55, 0.1)', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)' }}>
              {t.hours.lunch}
            </div>
            <div style={{ padding: '20px', background: 'rgba(212, 175, 55, 0.1)', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)' }}>
              {t.hours.dinner}
            </div>
          </div>
        </div>
      </section>
     {/* Contact Section */}
    <section id="contact" style={{
        padding: '120px 30px',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        color: '#fff'
        }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }} className="scale-in">
          <h2 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
            marginBottom: '30px', fontWeight: 700
          }}>
            {t.reservation}
          </h2>
          <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 60px' }} />
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '50px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <MapPin size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Adresse</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.address}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <Phone size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Téléphone</h3>
            <p style={{ fontSize: '16px' }}>{t.contact.phone}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <Mail size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Email</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.email}</p>
            </div>
          </div>

          <button style={{
            background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
            color: '#000', padding: '18px 50px', fontSize: '18px',
            border: 'none', borderRadius: '50px', cursor: 'pointer',
            fontWeight: 700, letterSpacing: '2px', transition: 'all 0.4s',
             }}
             onClick={() => navigate('/contact')}
             >
            Réserver Maintenant      
            </button>
        </div>
    </section>
    </div>
  );
};

export default RestaurantPage;